import { motion } from "framer-motion";
import { cn } from "kz-ui-sdk";

export interface StarBurstProps {
  size: {
    width: number;
    height: number;
  };
  numberOfStars?: number;
  duration?: number;
  className?: string;
  animate?: boolean;
  starSize?: {
    width: number;
    height: number;
  };
}

const initialKeyframes = {
  left: "50%",
  top: "50%",
  x: "-50%",
  y: "-50%",
  opacity: 0,
};

const StarBurst = ({
  size,
  numberOfStars = 16,
  duration = 4,
  className,
  animate = true,
  starSize = { width: 28, height: 28 },
}: StarBurstProps) => {
  const centerX = size.width / 2;
  const centerY = size.height / 2;
  const radius = Math.min(centerX, centerY) - Math.max(starSize.width, starSize.height) / 2;

  return (
    <div
      className={cn("absolute", className)}
      style={{
        width: size.width,
        height: size.height,
      }}
    >
      {Array.from({ length: numberOfStars }, (_, index) => {
        const baseAngle = (index * 360) / numberOfStars;
        const angleOffset = (Math.random() - 0.5) * 10; // 5deg random offset
        const angle = baseAngle + angleOffset;
        const angleRad = (angle * Math.PI) / 180;
        const endX = centerX + radius * Math.cos(angleRad);
        const endY = centerY + radius * Math.sin(angleRad);
        const selfRotate = Math.random() * 360;
        const selfScale = Math.random() * 0.3 + 1;

        return (
          <motion.img
            key={index}
            src="/images/mega-share/star.png"
            alt="star"
            className="absolute"
            style={{
              width: starSize.width,
              height: starSize.height,
            }}
            initial={{
              ...initialKeyframes,
              rotate: selfRotate,
              scale: selfScale,
            }}
            animate={
              animate
                ? {
                    left: `${endX}px`,
                    top: `${endY}px`,
                    x: "-50%",
                    y: "-50%",
                    opacity: [0, 1, 0],
                    rotate: selfRotate,
                    scale: selfScale,
                  }
                : {
                    ...initialKeyframes,
                    rotate: selfRotate,
                    scale: selfScale,
                  }
            }
            transition={
              animate
                ? {
                    duration,
                    delay: Math.random() * 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }
                : {}
            }
          />
        );
      })}
    </div>
  );
};

export default StarBurst;
